import { useState, useEffect, useRef } from 'react';
import { saveUserSettingsCookie } from '@Components/Utilities/CookieHelper';
import { sandhillsRequest } from '@Components/Utilities/SandhillsUtility';
import Combobox from '@Components/MuiWrappers/Combobox';
import Box from '@mui/material/Box';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { stringEqualsIgnoreCase } from '@Components/Utilities/SandhillsUtility';
import { useRecoilValue } from 'recoil';
import TranslationText from '@Components/Utilities/TranslationText';

const CountrySelector = (props) => {

    const {
        Countries,
        langCode
    } = props;

    const [countries, setCountries] = useState(Countries || []);
    const isInitialMount = useRef(false);

    useEffect(() => {
        if (isInitialMount.current && Countries && Countries.length > 0) {
            sandhillsRequest({
                url: routes.GetSelectableCountries,
                data: { languageCode: langCode }
            }).then((response) => {
                if (response && response.Countries.length > 0) {
                    setCountries(response.Countries);
                }
            });
        }

        isInitialMount.current = true;
    }, [langCode])
  
    const getOptionLabel = (option) => option.Country.Name;
    const routes = useRecoilValue(atoms.routes);

    const renderOption = (optionsProps, option) => {
        return (
            <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...optionsProps}>
                {option.HasFlagIcon && <img
                    loading="lazy"
                    height="20"
                    src={option.FlagUrl}
                    alt=""
                    className={option.FlagName}
                />}
                <div><span>{option.Country.Name}</span></div>
            </Box>
        );
    };
    const onChange = (event, option, reason, details) => {
        if (reason == 'selectOption') {
            const countryCode = option.CountryCode;
            if (props.onChange) {
                props.onChange(countryCode);
            } else {
                saveUserSettingsCookie({ countryCode: countryCode, url: routes.SaveUserSettings })
                    .then(data => {
                        window.location.href = data.url;
                    })
                    .catch(error => {
                        console.log('Error saving UserSettings cookie: ', error);
                        window.location.reload(true);
                    });
            }
        }
    };

    const getOptionIcon = (value) => {
        const selectedOption = countries.filter(c => c.HasFlagIcon && stringEqualsIgnoreCase(c.Country.Name, value))[0];
        if (selectedOption) {
            return <img
                loading="lazy"
                height="20"
                src={selectedOption.FlagUrl}
                alt=""
                className={selectedOption.FlagName}
            />;
        }
        return null;
    };

    return (
        <div className={props.containerClassName}>
            <Combobox
                label={<TranslationText tKey='sandhills.tradesites.mvc.selectyourregion' />}
                value={countries.filter(c => stringEqualsIgnoreCase(c.CountryCode, props.value))[0]}
                options={countries}
                getOptionLabel={getOptionLabel}
                renderOption={renderOption}
                onChange={onChange}
                popperDisablePortal={props.popperDisablePortal}
                InputProps={{
                    startAdornment: getOptionIcon
                }}
            />
        </div>
    );
};
export default CountrySelector;
